// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactNode, ReactElement, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

import './SortableItemList.scss';

interface SortableListProps {
    children: ReactNode;
    dragType: string;
    moveItem: (newIndex: number, oldIndex: number) => void;
    index: number;
}

const SortableItemList = ({ children, dragType, moveItem, index }: SortableListProps): ReactElement => {
    const ref = useRef(null);
    const [{ isDragging }, drag] = useDrag({
        item: { type: dragType },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (dropResult) {
                moveItem?.(dropResult.newIndex, index);
            }
        },
    });

    const [{ isOver }, drop] = useDrop({
        accept: dragType,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
        drop: () => ({ newIndex: index }),
    });

    drag(drop(ref));

    return (
        <div ref={ref} className={classList('sortable-list', { dragged: isDragging, over: isOver })}>
            {children}
        </div>
    );
};

export default SortableItemList;
